/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2024, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import axios from 'axios';
import _ from 'lodash';

import { Account } from '../../../../ts/account';
import { endpoints } from '../../../ia/util/config';

const buildPlanUpgradeURL = (region: string, instance: string) => {
  return `${endpoints.bluemix}/instances/${region}/${encodeURIComponent(
    instance
  )}`;
};

const buildAccountDetailsURL = (accountId: string) => {
  return `${endpoints.bluemix}/accounts/${accountId}`;
};

const buildAccountUsageURL = (accountId: string) => {
  return `${endpoints.bluemix}/accounts/${accountId}/usage`;
};

export const upgradePlan = async (
  region: string,
  instance: string,
  planName: string
): Promise<void> => {
  const url = buildPlanUpgradeURL(region, instance);
  try {
    const response = await axios.patch(url, { planName });
    return response.data;
  } catch (error) {
    return await Promise.reject(_.get(error, 'response.data') || error);
  }
};

export const getAccountDetail = async (accountId: string): Promise<Account> => {
  const url = buildAccountDetailsURL(accountId);
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    return await Promise.reject(_.get(error, 'response.data') || error);
  }
};

export const getAccountUsage = async (accountId: string): Promise<unknown> => {
  const url = buildAccountUsageURL(accountId);
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    return await Promise.reject(_.get(error, 'response.data') || error);
  }
};
